import { API_AUTH } from "./common";

const QuanLyThuChiNgoaiLeApi = {
  list: ({
    tungay,
    denngay,
    ten,
    nhanvien,
    loaiphieu,
    pageIndex,
    pageSize,
    hinhThucThanhToan,
  }) =>
    API_AUTH.get(
      `thu-chi-ngoai-le/danh-sach-thu-chi-ngoai-le?tungay=${tungay}&denngay=${denngay}&ten=${ten}&nhanvien=${nhanvien}&loaiphieu=${loaiphieu}&pageIndex=${pageIndex}&pageSize=${pageSize}&hinhThucThanhToan=${hinhThucThanhToan}`,
      {}
    ),
  xoaPhieuThuChi: (thuchiId) => {
    return API_AUTH.post(
      `thu-chi-ngoai-le/xoa-thu-chi?thuchiId=${thuchiId}`,
      {}
    );
  },
  chiTietThuChiNgoaiLe: (thuchiId) => {
    return API_AUTH.get(
      `thu-chi-ngoai-le/chi-tiet-thu-chi-ngoai-le?thuchiId=${thuchiId}`,
      {}
    );
  },
  loaiThuChi: (type) => {
    return API_AUTH.get(`loai-thu-chi/combo?type=${type}`, {});
  },
  loaiThuChi1: (type) => {
    return API_AUTH.get(`loai-thu-chi/combo1?type=${type}`, {});
  },
  totalLoaiThuChi: () => {
    return API_AUTH.get(`thu-chi-ngoai-le/loai-thu-chi-ngoai-le`, {});
  },

  cauHinhPhanBoChiPhiNgoaiLe: () => {
    return API_AUTH.get(`thu-chi-ngoai-le/cau-hinh-phan-bo-chi-phi`, {});
  },

  addThuNgoaiLe: (
    ngaythuchi,
    nhanviennhantien,
    nguoinop,
    sotien,
    loaiphieu,
    ghichu,
    isLoiNhuan,
    isPhanBoChiPhi,
    soThang,
    tuThang,
    tuNam,
    dataPhanBo
  ) =>
    API_AUTH.post(`thu-chi-ngoai-le/them-phieu-thu`, {
      ngaythuchi,
      nhanviennhantien,
      nguoinop,
      sotien,
      loaiphieu,
      ghichu,
      isLoiNhuan,
      isPhanBoChiPhi,
      soThang,
      tuThang,
      tuNam,
      dataPhanBo,
    }),

  editThuNgoaiLe: (
    thuchiId,
    ngaythuchi,
    nhanviennhantien,
    nguoinop,
    sotien,
    loaiphieu,
    ghichu,
    isLoiNhuan
  ) =>
    API_AUTH.post(
      `thu-chi-ngoai-le/sua-phieu-thu?thuchiId=${thuchiId}&ngaythuchi=${ngaythuchi}&nhanviennhantien=${nhanviennhantien}&nguoinop=${nguoinop}&sotien=${sotien}&loaiphieu=${loaiphieu}&ghichu=${ghichu}&isLoiNhuan=${isLoiNhuan}`,
      {}
    ),

  addChiNgoaiLe: (
    ngaythuchi,
    nhanviennhantien,
    nguoinop,
    sotien,
    loaiphieu,
    ghichu,
    isLoiNhuan,
    isPhanBoChiPhi,
    soThang,
    tuThang,
    tuNam,
    dataPhanBo
  ) =>
    API_AUTH.post(`thu-chi-ngoai-le/them-phieu-chi`, {
      ngaythuchi,
      nhanviennhantien,
      nguoinop,
      sotien,
      loaiphieu,
      ghichu,
      isLoiNhuan,
      isPhanBoChiPhi,
      soThang,
      tuThang,
      tuNam,
      dataPhanBo,
    }),

  editChiNgoaiLe: (
    thuchiId,
    ngaythuchi,
    nhanviennhantien,
    nguoinop,
    sotien,
    loaiphieu,
    ghichu,
    isLoiNhuan
  ) =>
    API_AUTH.post(
      `thu-chi-ngoai-le/sua-phieu-chi?thuchiId=${thuchiId}&ngaythuchi=${ngaythuchi}&nhanviennhantien=${nhanviennhantien}&nguoinop=${nguoinop}&sotien=${sotien}&loaiphieu=${loaiphieu}&ghichu=${ghichu}&isLoiNhuan=${isLoiNhuan}`,
      {}
    ),
};

export default QuanLyThuChiNgoaiLeApi;
